<template>
  <loading v-if="isLoading"></loading>
  <template v-if="!isLoading && kintaiSummary">

    <div class="flex flex-align-center button-area summary-edit-buttons"
      v-if="!isLoading && kintaiSummary && authStore.hasPermission(PermissionConst.SOUMU_DAKOKU_KAKUNIN)">
      <button v-if="!isSummaryEditMode" class="btn info" @click="switchSummaryEditMode(true)"
        :disabled="kintaiSummary.syounin_status_type !== OptionConst.SYOUNIN_STATUS.APPROVED">サマリー編集</button>
      <p v-if="kintaiSummary.syounin_status_type !== OptionConst.SYOUNIN_STATUS.APPROVED">※サマリー編集はタイムシート確定済み状態でのみ行なえます</p>
      <template v-if="isSummaryEditMode">
        <button class="btn success" @click="update()">更新</button>
        <button class="btn cancel" @click="switchSummaryEditMode(false)">キャンセル</button>
      </template>
    </div>

    <table class="summary-table">
      <tr>
        <th>所定労働日数</th>
        <td class="syotei-workDay" v-if="!isSummaryEditMode">{{ kintaiSummary?.syotei_work_days }}</td>
        <td class="syotei-workDay edit" v-else-if="summaryEditData">
          <input-text type="text" v-model="summaryEditData.syotei_work_days" />
        </td>

        <th>平日出勤日数</th>
        <td class="heijitsu-syukkin" v-if="!isSummaryEditMode">{{ kintaiSummary?.heijitsu_syukkin_days }}</td>
        <td class="heijitsu-syukkin edit" v-else-if="summaryEditData">
          <input-text type="text" v-model="summaryEditData.heijitsu_syukkin_days" />
        </td>

        <th>休日出勤日数 </th>
        <td class="kyuujitsu-syukkin" v-if="!isSummaryEditMode">{{ kintaiSummary?.kyuujitsu_syukkin_days }}</td>
        <td class="kyuujitsu-syukkin edit" v-else-if="summaryEditData">
          <input-text type="text" v-model="summaryEditData.kyuujitsu_syukkin_days" />
        </td>

        <th>公休日数</th>
        <td class="koukyuu" v-if="!isSummaryEditMode">{{ kintaiSummary?.koukyuu_days }}</td>
        <td class="koukyuu edit" v-else-if="summaryEditData">
          <input-text type="text" v-model="summaryEditData.koukyuu_days" />
        </td>

        <th>有給日数</th>
        <td class="yuukyuu" v-if="!isSummaryEditMode">{{ kintaiSummary?.yuukyuu_days }}</td>
        <td class="yuukyuu edit" v-else-if="summaryEditData"><input-text type="text"
            v-model="summaryEditData.yuukyuu_days" />
        </td>
        <th>その他の休日数</th>
        <td class="sonotaKyuujitsu" v-if="!isSummaryEditMode">{{ kintaiSummary?.sonota_kyuujitsu_days }}</td>
        <td class="sonotaKyuujitsu edit" v-else-if="summaryEditData">
          <input-text type="text" v-model="summaryEditData.sonota_kyuujitsu_days" />
        </td>
      </tr>

      <tr>
        <th>
          <template v-if="authStore.hasPermission(PermissionConst.KINTAI_MANAGE_FOR_HAKENSAKI)">合計勤務時間</template>
          <template v-else>所定労働時間</template>
        </th>
        <td class="syotei-work-time" v-if="!isSummaryEditMode">{{ kintaiSummary?.syotei_work_times }}</td>
        <td class="syotei-work-time edit" v-else-if="summaryEditData">
          <input-text type="text" v-model="summaryEditData.syotei_work_times" />
        </td>

        <th>控除時間</th>
        <td class="koujo-time" v-if="!isSummaryEditMode">{{ kintaiSummary?.koujo_times }}</td>
        <td class="koujo-time edit" v-else-if="summaryEditData">
          <input-text type="text" v-model="summaryEditData.koujo_times" />
        </td>

        <th>法定内残業</th>
        <td class="houteinai-zangyou" v-if="!isSummaryEditMode">{{ kintaiSummary?.houteinai_zangyou_times }}</td>
        <td class="houteinai-zangyou edit" v-else-if="summaryEditData">
          <input-text type="text" v-model="summaryEditData.houteinai_zangyou_times" />
        </td>

        <th>時間外</th>
        <td class="zangyou" v-if="!isSummaryEditMode">{{ kintaiSummary?.zangyou_times }}</td>
        <td class="zangyou edit" v-else-if="summaryEditData">
          <input-text type="text" v-model="summaryEditData.zangyou_times" />
        </td>

        <th>休日残業時間</th>
        <td class="kyuujitsu-zangyou" v-if="!isSummaryEditMode">{{ kintaiSummary?.kyuujitsu_zangyou_times }}</td>
        <td class="kyuujitsu-zangyou edit" v-else-if="summaryEditData">
          <input-text type="text" v-model="summaryEditData.kyuujitsu_zangyou_times" />
        </td>

        <th>深夜割増時間</th>
        <td class="shinya-warimashi" v-if="!isSummaryEditMode">{{ kintaiSummary?.shinya_warimashi_times }}</td>
        <td class="shinya-warimashi edit" v-else-if="summaryEditData">
          <input-text type="text" v-model="summaryEditData.shinya_warimashi_times" />
        </td>
      </tr>

      <tr>
        <th>遅刻回数</th>
        <td class="chikoku" v-if="!isSummaryEditMode">{{ kintaiSummary?.chikoku_count }}</td>
        <td class="chikoku edit" v-else-if="summaryEditData">
          <input-text type="text" v-model="summaryEditData.chikoku_count" />
        </td>

        <th>早退回数</th>
        <td class="soutai" v-if="!isSummaryEditMode">{{ kintaiSummary?.soutai_count }}</td>
        <td class="soutai edit" v-else-if="summaryEditData">
          <input-text type="text" v-model="summaryEditData.soutai_count" />
        </td>

        <th>欠勤日数</th>
        <td class="kekkin" v-if="!isSummaryEditMode">{{ kintaiSummary?.kekkin_days }}</td>
        <td class="kekkin edit" v-else-if="summaryEditData">
          <input-text type="text" v-model="summaryEditData.kekkin_days" />
        </td>

        <th>日直回数</th>
        <td class="nittyoku" v-if="!isSummaryEditMode">{{ kintaiSummary.nittyoku_count }}</td>
        <td class="nittyoku edit" v-else-if="summaryEditData">
          <input-text type="text" v-model="summaryEditData.nittyoku_count" />
        </td>
        <td colspan="4" class="blank"></td>
      </tr>
    </table>

    <div class="for-soumu" v-if="Config.APP_DEBUG || authStore.hasPermission(PermissionConst.SOUMU_DAKOKU_KAKUNIN)">
      <h3>総務用</h3>
      <p>このセクションでは打刻者には表示されない項目の表示／編集を行えます。</p>  
      <p v-if="Config.APP_DEBUG">※このセクションはデバッグ環境（Config.APP_DEBUG = trueの環境）では権限に関わらず表示されます（この行はデバッグ環境のみで表示されます）</p>
      <table class="summary-table for-soumu">
        <tr>
          <th>
            時間外（包括時間差引後）
          </th>
          <td class="zangyou-sasihiki-times" v-if="!isSummaryEditMode">
            {{ kintaiSummary?.zangyou_sashihiki_times }}
             <br>
            基本計算式：時間外 - 雇用契約上の包括時間<br>※結果が0:00以下の場合は0:00とする
          </td>
          <td class="zangyou-sasihiki-times edit" v-else-if="summaryEditData">
            <input-text type="text" v-model="summaryEditData.zangyou_sashihiki_times" /><br>
            基本計算式：時間外 - 雇用契約上の包括時間<br>※結果が0:00以下の場合は0:00とする
          </td>
          <th>
            出勤時間<br>※時給社員用のPX連携項目（原則、月給社員は値なし）
          </th>
          <td class="zangyou-sasihiki-times" v-if="!isSummaryEditMode">
            {{ kintaiSummary?.syukkin_times ? kintaiSummary?.syukkin_times : "-" }}
          </td>
          <td class="zangyou-sasihiki-times edit" v-else-if="summaryEditData">
            <input-text type="text" v-model="summaryEditData.syukkin_times" />
          </td>
        </tr>
        <!-- 
        <tr>
          <th>休日残業時間（上表と同値）</th>
          <td class="kyuujitsu-zangyou" v-if="!isSummaryEditMode">
            {{ kintaiSummary?.kyuujitsu_zangyou_times }}
          </td>
          <td class="kyuujitsu-zangyou edit" v-else-if="summaryEditData">
            <input-text type="text" v-model="summaryEditData.kyuujitsu_zangyou_times" disabled />
          </td>

          <th>休日残業時間（包括時間差引後／包括時間：{{ kintaiSummary?.houkatsu_times }}）</th>
          <td class="kyuujitsu-zangyou-sasihiki-times" v-if="!isSummaryEditMode">
            {{ kintaiSummary?.kyuujitsu_zangyou_sashihiki_times }}
          </td>
          <td class="kyuujitsu-zangyou-sasihiki-times edit" v-else-if="summaryEditData">
            <input-text type="text" v-model="summaryEditData.kyuujitsu_zangyou_sashihiki_times" />
          </td>
        </tr>
      -->

      </table>
    </div>
  </template>
  <p v-else-if="(!isLoading && !kintaiSummary)">表示できる内容がありません</p>
</template>

<script lang="ts">
import { Ref, defineComponent, onMounted, ref, toRefs, watch } from "vue"
import DakokuSyuusei from "@/components/dakoku/DakokuSyuusei.vue"
import { useKintaiSummary } from "@/composable/kinmu/summary"
import { KintaiSummaryData } from "@/types/Dakoku"
import { timeToHHmm } from "@/filters/common"
import { useAuthStore } from "@/store/auth"
import { PermissionConst } from "@/const/Permission"
import OptionConst from "@/const/Option"
import { cloneDeep } from "lodash"
import { DialogService } from "@/service/DialogService"
import Config from "@/const/Config"

export default defineComponent({
  props: {
    koyouKeiyakuId: {
      type: Number,
      default: null
    },
    syuugyouBasyoId: {
      type: Number,
      default: null
    },
    userId: {
      type: Number as () => number | null,
      default: null
    },
    year: {
      type: Number,
      default: null
    },
    month: {
      type: Number,
      default: null
    },
    execLoad: {
      type: Boolean,
      default: false
    },
  },
  emits: {
    loaded(summamry: KintaiSummaryData | null) {
      return summamry
    }
  },
  setup(props, context) {
    const { getKintaiSummary, kintaiSummary, modifyKintaiSummary } = useKintaiSummary()
    const { execLoad } = toRefs(props)
    const authStore = useAuthStore()

    let isSummaryEditMode = ref(false)
    const summaryEditData: Ref<KintaiSummaryData | null> = ref(null)

    const isLoading = ref(false)

    onMounted(async () => {
      await getSummary()
    })

    const getSummary = async () => {
      isLoading.value = true
      if (props.syuugyouBasyoId && props.year && props.month) {
        await getKintaiSummary(props.year, props.month, props.syuugyouBasyoId, props.koyouKeiyakuId, props.userId)
        if (kintaiSummary.value) {
          // フォーマット
          await formatSummuryTimes()
        }
      }
      isLoading.value = false
      context.emit('loaded', kintaiSummary.value)
    }

    watch([execLoad], async () => {
      console.log('サマリーの更新', execLoad.value)
      // タイムシート画面で月変更などした場合に走る
      if (execLoad.value) {
        // 編集フラグと編集データの初期化
        // 本当はここでswitchSummaryEditModeを走らせて確認してから月変更させたいが親側で待ってくれないのでやむなし
        // switchSummaryEditModeでの編集終了確認を待ってからの制御は結構複雑になりそうなので今は行わない（24.1.11 大塚）
        summaryEditData.value = null
        isSummaryEditMode.value = false

        // サマリー再取得
        await getSummary()
      }
    })

    // 勤怠サマリの時間表示をフォーマット
    const formatSummuryTimes = (async () => {
      if (kintaiSummary.value) {
        kintaiSummary.value.syotei_work_times = timeToHHmm(kintaiSummary.value.syotei_work_times)
        kintaiSummary.value.koujo_times = timeToHHmm(kintaiSummary.value.koujo_times)
        kintaiSummary.value.houteinai_zangyou_times = timeToHHmm(kintaiSummary.value.houteinai_zangyou_times)
        kintaiSummary.value.zangyou_times = timeToHHmm(kintaiSummary.value.zangyou_times)
        kintaiSummary.value.shinya_zangyou_times = timeToHHmm(kintaiSummary.value.shinya_zangyou_times)
        kintaiSummary.value.kyuujitsu_zangyou_times = timeToHHmm(kintaiSummary.value.kyuujitsu_zangyou_times)
        kintaiSummary.value.kyuujitsu_shinya_zangyou = timeToHHmm(kintaiSummary.value.kyuujitsu_shinya_zangyou)
        kintaiSummary.value.shinya_warimashi_times = timeToHHmm(kintaiSummary.value.shinya_warimashi_times)
        kintaiSummary.value.zangyou_sashihiki_times = timeToHHmm(kintaiSummary.value.zangyou_sashihiki_times)

        kintaiSummary.value.shinya_zangyou_sashihiki_times = timeToHHmm(kintaiSummary.value.shinya_zangyou_sashihiki_times)
        kintaiSummary.value.shinya_zangyou_sashihiki_times = timeToHHmm(kintaiSummary.value.shinya_zangyou_sashihiki_times)
        kintaiSummary.value.houkatsu_times = timeToHHmm(kintaiSummary.value.houkatsu_times) // ※デバッグ用
      }
    })

    // 編集モードと非編集モードの切替
    const switchSummaryEditMode = async (flag: boolean) => {
      if (flag) {

        // PX連携済みの場合、すでに給与計算に使用されている可能性があるため確認する（24.1.11 大塚）
        if (kintaiSummary.value?.is_px) {
          const dialogResult = await DialogService.warning({
            html: 'このサマリーはPX連携済みです。<br>更新する場合、業務に支障が出ないよう適宜社内で情報共有等の対応をしてください。',
            confirmButtonText: '更新を始める',
            showCancelButton: true,
            cancelButtonText: 'やめる',
          })

          if (!dialogResult.isConfirmed) {
            return
          }
        }

        // 編集用オブジェクトへディープコピー
        summaryEditData.value = cloneDeep(kintaiSummary.value)
      } else {
        if (isSummaryEditMode.value === true) {
          // 編集モードの場合は確認をする
          const dialogResult = await DialogService.question({
            html: 'サマリー編集を終了しますか？<br>更新ボタンを押していない場合、入力内容は失われます',
            showCancelButton: true,
            confirmButtonText: 'はい',
            cancelButtonText: 'いいえ',
          })

          if (!dialogResult.isConfirmed) {
            return
          }
        }
        // 編集用オブジェクトを空にする
        summaryEditData.value = null
      }

      // 引数で受け取った値を編集モード制御用フラグに代入する
      isSummaryEditMode.value = flag
    }

    // 更新処理
    const update = async () => {
      if (await modifyKintaiSummary(summaryEditData.value)) {
        await DialogService.info({
          html: "更新に成功しました。再読込します。"
        })

        // 編集フラグと編集データの初期化
        summaryEditData.value = null
        isSummaryEditMode.value = false

        // サマリー再取得
        await getSummary()
      }
    }

    return {
      kintaiSummary,
      authStore,
      PermissionConst,
      OptionConst,
      isSummaryEditMode,
      switchSummaryEditMode,
      update,
      summaryEditData,
      isLoading,
      Config
    }
  },
  components: {
    'dialog-dakoku-syuusei': DakokuSyuusei
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/kinmu-summary.scss';
</style>
